<div class="container dark-grey-text mt-5">
    <h2>Recepient Details</h2>
    <div class="row">
        <div class="form-group  col-md-6">
            <p class="font-weight-bold">Receiver Number</p>

            <vue-phone-number-input id="Umbai" v-model="receiverNumber" default-country-code="ZW"
                no-example required size="lg" maxlength="12" @update="ValidateReceiverNumber" />
            <div><span class="text-warning">{{valideReceiverNumberMessage}}</span></div>
        </div>
        <div class="form-group col-md-6">
            <p class="font-weight-bold">Sender Number</p>
            <vue-phone-number-input id="Umbai" v-model="senderNumber" default-country-code="ZA"
                required size="lg" no-example maxlength="12" @update="ValidateSenderNumber" />
            <div><span class="text-warning">{{valideSenderNumberMessage}}</span></div>
        </div>
    </div>
    <div class="row">
        <div class="form-group  col-md-6">
            <p class="font-weight-bold">Receiver First Name</p>
            <input v-model="recepient.firstName" type="text" class="form-control form-control"
                required placeholder="First Name*">
                <div><span class="text-warning">{{valideReceiverFirstNameMessage}}</span></div>
        </div>
        <div class="form-group  col-md-6">
            <p class="font-weight-bold">Receiver Middle Name</p>
            <input v-model="recepient.middleName" type="text" class="form-control form-control"
                required placeholder="Middle Name">
        </div>
    </div>
    <div class="row mb-3">
        <div class="form-group  col-md-6">
            <p class="font-weight-bold">Receiver Surname</p>
            <input v-model="recepient.surname" type="text" class="form-control form-control"
                required placeholder="Receiver Surname *">
                <div><span class="text-warning">{{valideReceiverSurnameMessage}}</span></div>
        </div>
    </div>
    <base-button class="btn-3" @click='proceed()' type="primary" icon="ni ni-credit-card">
                            Proceed</base-button>
</div>